/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

import DeviceGroupRoutes from "./device-group.routes";
import AddDeviceGroupController from './add-device-group.controller';
import DeviceGroupDirective from './device-group.directive';
import DeviceGroupTableConfig from './device-group-table.config';

export default angular.module('tektelic.deviceGroup', [])
    .config(DeviceGroupRoutes)
    .controller('AddDeviceGroupController', AddDeviceGroupController)
    .directive('tkDeviceGroup', DeviceGroupDirective)
    .factory('deviceGroupTableConfig', DeviceGroupTableConfig)
    .name;



// WEBPACK FOOTER //
// ./src/app/device-group/index.js